import { Dialog } from "@omnia/shared/shell/dialog";
import { defineComponent, IOmniaShell, isUndefinedOrNull } from "../../../omnia"
import { INutritionPlan, IPlanUpdateModel } from "../../../types"
import { PlanEditContext } from "../editContext"

export class ConfirmDlg extends Dialog {

    static create(): ng.IDirective {
        return defineComponent(ConfirmDlg, "app/nutrition/plan/edit/confirm/confirm.html");
    }

    private plan: INutritionPlan
    public recalculate: boolean

    public hasManualEdits: boolean
    public resetManualEdits: boolean

    private mergeAppZonesChanged = false

    static $inject = ["$scope", "OmniaShell"]

    constructor($scope, shell: IOmniaShell) {
        super($scope, shell)
    }

    $onInit() {

        const args: {
            ctxt: PlanEditContext
            plan: INutritionPlan,
            initialPlan: INutritionPlan
        } = this.arguments.args

        const { plan } = args

        this.plan = plan
        this.mergeAppZonesChanged = args.initialPlan?.MergeAppZones != plan?.MergeAppZones
        this.recalculate = plan && (plan.ShouldRecalculate || this.mergeAppZonesChanged)
        this.resetManualEdits = undefined
        this.hasManualEdits = plan.Applications.some(s => s.ZoneLevelEdits)


    }

    get showManualRatesWarning() {
        return this.hasManualEdits && this.mergeAppZonesChanged && (this.resetManualEdits === false)
    }

    canCommit() {
        if (isUndefinedOrNull(this.recalculate)) return false
        if (this.hasManualEdits && isUndefinedOrNull(this.resetManualEdits)) return false
        return true
    }

    commit() {

        const result: IPlanUpdateModel = {
            plan: this.plan,
            recalculate: !!this.recalculate,
            resetEdits: !!this.resetManualEdits
        }

        this.close(result)

    }

}
